<template>
  <div>
  <el-dialog title="每日分红调整" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-form size="small" :model="form">
      <el-form-item label="日期" :label-width="formLabelWidth">
        <el-input v-model="form.date_time_text" autocomplete="off" disabled></el-input>
      </el-form-item>
      <el-form-item label="今日累计奖金池" :label-width="formLabelWidth">
        <el-input v-model="form.money" autocomplete="off" disabled></el-input>
      </el-form-item>
      
      <el-form-item label="今日减免金额" :label-width="formLabelWidth">
        <el-input v-model="form.dec_money" min="0" autocomplete="off"></el-input>
        <div class="lh18 mt10 red">
          <p>注：设置后实际分红总额=累计-减免金额</p>
        </div>
      </el-form-item>
      
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="editInfo" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
   <!--用户选择-->
  <GetUser :is_open="open_user" @close="closeUserDialog"></GetUser>
  </div>
</template>

<script>
  import BonusApi from '@/api/weightbonus.js';
  export default {
    data() {
      return {
         open_user: false,
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        loading: false,
        dialogVisible: false,
      };
    },
    props: ['open_edit', 'form'],
    created() {

      this.dialogVisible = this.open_edit;

    },
    methods: {

      /*修改用户*/
      editInfo() {
        let self = this;
        self.loading = true;
        let params = self.form;
        BonusApi.editDaily(params, true)
          .then(data => {
            self.loading = false;
            if (data.code == 1) {
              self.$message({
                message: '用户修改成功',
                type: 'success'
              });
              self.dialogFormVisible(true);
            }
          })
          .catch(error => {
            self.loading = false;
          });
      },

      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },
      /*打开用户弹窗*/
    openUserDialog() {
      this.open_user = true;
    },
    /*关闭用户弹窗*/
    closeUserDialog(e) {
      if (e.type != 'error') {
        this.user = e.params[0];
        this.form.referee_id = e.params[0].user_id;
      }
      this.open_user = false;
    },


    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/weightbonus/bonus/dialog/Dailyedit.vue